import React, { useState } from 'react';
import './free-grants.css';

/**
 * Revoke confirmation (065).
 *
 * The warning is not boilerplate: revoking withdraws the member's ACCESS, but a store deferral or
 * cancellation already made for this grant cannot be undone — neither Apple nor Google exposes an
 * "un-defer" or "un-cancel" call. An admin who revokes expecting billing to snap back would be
 * wrong, so the dialog says it before they commit, not after.
 */

const BILLING_TOUCHED = ['deferred', 'extended', 'partial', 'auto_renew_cancelled'];

export default function RevokeConfirm({ grant, onCancel, onConfirm, submitting }) {
  const [reason, setReason] = useState('');
  const billingWasChanged = BILLING_TOUCHED.includes(grant?.billing_action);
  const canSubmit = reason.trim().length > 0 && !submitting;

  return (
    <div className="fg-modal-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="fg-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fg-revoke-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fg-modal-head">
          <h6 id="fg-revoke-title">Revoke free access</h6>
          <p>{grant?.user_name || `User ${grant?.user_id}`} · {grant?.length_label}</p>
        </div>

        <div className="fg-modal-body">
          <p style={{ margin: 0, fontSize: 13 }}>
            This withdraws the {grant?.length_label?.toLowerCase()} this grant added. The member
            keeps everything they had before it.
          </p>

          {billingWasChanged && (
            <div className="fg-alert fg-alert--warn" data-testid="fg-revoke-billing-warning">
              Store billing cannot be reversed. This grant already changed the member’s payments
              at the store, and neither Apple nor Google allows that to be undone.
            </div>
          )}

          <div className="fg-field">
            <label htmlFor="fg-revoke-reason">Reason (required)</label>
            <input
              id="fg-revoke-reason"
              className="fg-input"
              type="text"
              maxLength={500}
              placeholder="e.g. Granted to the wrong account"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>

        <div className="fg-modal-foot">
          <button type="button" className="fg-btn" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button
            type="button"
            className="fg-btn fg-btn--danger"
            onClick={() => onConfirm(reason.trim())}
            disabled={!canSubmit}
          >
            {submitting ? 'Revoking…' : 'Revoke access'}
          </button>
        </div>
      </div>
    </div>
  );
}
